<personal-email-history-table [emails]="personalEmails"></personal-email-history-table>